// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** function to get dimensions
  usage example to get \`tablet\` value from \`\$page-max-widths\`
  .class {
    max-width: dim(\$page-max-widths, tablet);
  }

 */
.validation-error-tooltip-module__validation-error-tooltip___qLhzF {
  background-color: var(--red600, #c12335);
  transition: 0.3s ease-out opacity, 0.3s ease-out transform;
  color: var(--surface1, #fff);
  padding: 8px 16px;
  border-radius: 4px;
  position: relative;
  font-size: 0.75rem;
  font-weight: 600;
}
.validation-error-tooltip-module__validation-error-tooltip__arrow___IDtZh {
  margin-top: 8px;
}
.validation-error-tooltip-module__validation-error-tooltip__arrow___IDtZh::before {
  content: "";
  width: 16px;
  height: 16px;
  background-color: var(--red600, #c12335);
  transform: rotate(45deg) translateY(calc(-50% + 6px));
  border-radius: 3px;
  position: absolute;
  top: 0;
  right: 20px;
  z-index: -1;
}`, "",{"version":3,"sources":["webpack://./node_modules/wa-storybook/styles/tools/functions/_widths.scss","webpack://./node_modules/wa-storybook/components/inputs/validation-error-tooltip/validation-error-tooltip.module.scss"],"names":[],"mappings":"AAAA;;;;;;EAAA;ACEA;EACE,wCAAA;EACA,0DAAA;EACA,4BAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AAMF;AAJE;EACE,eAAA;AAMJ;AAJI;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,wCAAA;EACA,qDAAA;EACA,kBAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;AAMN","sourcesContent":["/** function to get dimensions\n  usage example to get `tablet` value from `$page-max-widths`\n  .class {\n    max-width: dim($page-max-widths, tablet);\n  }\n\n */\n\n@function dim($prop, $key) {\n  @return map-get($prop, $key);\n}\n","@import '../../../styles/utils';\n\n.validation-error-tooltip {\n  background-color: color(red600);\n  transition: 0.3s ease-out opacity, 0.3s ease-out transform;\n  color: color(surface1);\n  padding: 8px 16px;\n  border-radius: 4px;\n  position: relative;\n  font-size: rem(12);\n  font-weight: 600;\n\n  &__arrow {\n    margin-top: 8px;\n\n    &::before {\n      content: '';\n      width: 16px;\n      height: 16px;\n      background-color: color(red600);\n      transform: rotate(45deg) translateY(calc(-50% + 6px));\n      border-radius: 3px;\n      position: absolute;\n      top: 0;\n      right: 20px;\n      z-index: -1;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"validation-error-tooltip": `validation-error-tooltip-module__validation-error-tooltip___qLhzF`,
	"validation-error-tooltip__arrow": `validation-error-tooltip-module__validation-error-tooltip__arrow___IDtZh`
};
export default ___CSS_LOADER_EXPORT___;
